import React from 'react';
import Logo from './logo.png';
import { PopupButton } from 'react-calendly';

const Header = () => {
  const menuItems = [
    { name: 'Home', href: '/' },
    { name: 'Fintech', href: '#fintech' },
    { name: 'Services', href: '#services' },
    { name: 'Contact Us', href: '#contact' },
  ];

  return (
    <header className="w-[100vw] bg-[#f5f5f590] py-3 shadow-sm sticky top-0 z-50">
      <div className="w-full mx-auto px-8 py-4 flex items-end justify-between">
        <img src={Logo} alt="Logo" className="w-[100px] h-auto object-contain" />
        <nav className="flex items-center gap-6 text-none">
          {menuItems.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="text-lg font-semibold text-gray-800 hover:text-black transition-all"
            >
              {item.name}
            </a>
          ))}
          <PopupButton
            url="https://calendly.com/mydatalab?hide_gdpr_banner=1"
            rootElement={document.getElementById('root')}
            text="Book a call"
            className="bg-[#FF8F3E] text-lg text-white px-8 py-2 rounded hover:bg-[#e57d2f] transition"
          />
        </nav>
      </div>
    </header>
  );
};

export default Header;
